import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as mtdActions from '../../actions/mtdActions';
import * as chartDataTypeActions from '../../actions/chartDataTypeActions';
import * as kpiActions from '../../actions/kpiActions';
import * as submissionsTypeActions from '../../actions/submissionsTypeActions';
import SubmissionsKpiDataListControls from './SubmissionsKpiDataListControls';
import SubmissionsKpiDataList from './SubmissionsKpiDataList';
import SubmissionsKpiDataChart from './SubmissionsKpiDataChart';
import utils from '../../lib/utils';

export class SubmissionsKpiData extends React.Component {
  constructor(props) {
    super(props);
    this.boundChangeOfMonthYear = this.changeOfMonthYear.bind(this);
    this.boundChangeOfYear = this.changeOfYear.bind(this);
    this.boundChangeOfType = this.changeOfType.bind(this);
    const dates = utils.getMomentEndAndStartDateByMonth(
      utils.getMomentDateByKey('currentDate').format('YYYY-MM-DD')
    );
    this.state = {
      dateRange: {
        start: dates.start,
        end: dates.end
      },
      infoModalOpen: false
    };
    this.fetchData(
      this.state.dateRange.start,
      this.state.dateRange.end,
      props.submissionsType,
      props.selectedPartner
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedPartner && this.props.selectedPartner !== prevProps.selectedPartner){
      this.fetchData(
        this.state.dateRange.start,
        this.state.dateRange.end,
        this.props.submissionsType,
        this.props.selectedPartner
      );
    }
  }

  fetchData(startDate, endDate, dealType, partner){
    return this.props.kpiActions.fetchKpiData({
      startDate,
      endDate,
      dealType,
      partner
    });
  }

  changeDatesRange(dates) {
    this.setState({
      dateRange: dates
    });
    this.fetchData(
      dates.start,
      dates.end,
      this.props.submissionsType,
      this.props.selectedPartner
    );
  }

  changeOfYear(e) {
    this.props.mtdActions.setMTD(false);
    const dates = utils.getMomentEndAndStartDateByYear(
      e.target.value
    );
    this.changeDatesRange(dates);
  }

  changeOfMonthYear(e) {
    this.props.mtdActions.setMTD(true);
    const dates = utils.getMomentEndAndStartDateByMonth(
      e.target.value
    );
    this.changeDatesRange(dates);
  }

  changeOfType(e) {
    const typeToSet = `${e.target.value}`;
    this.props.submissionsTypeActions.setSubmissionsType(typeToSet);
    this.fetchData(
      this.state.dateRange.start,
      this.state.dateRange.end,
      e.target.value,
      this.props.selectedPartner
    );
  }

  renderTitleColumn() {
    return (
      <div className="submissions-kpi-data-container__actions-info column">
        <h3 className="submissions-kpi-data-container__actions-title title is-5">Performance Indicators</h3>
      </div>
    );
  }

  renderControlsColumn() {
    return (
      <div className="submissions-kpi-data-container__actions-wrap column">
        <SubmissionsKpiDataListControls
          activeControl={this.props.mtd ? 'MTD' : 'YTD'}
          changeOfYear={this.boundChangeOfYear}
          changeOfMonthYear={this.boundChangeOfMonthYear}
          changeOfType={this.boundChangeOfType}
        />
      </div>
    );
  }

  renderChartColumn() {
    return (
      <div className="submissions-kpi-data-container__chart column">
        <SubmissionsKpiDataChart
          data={this.props.kpis}
        />
      </div>
    );
  }

  renderListColumn() {
    return (
      <div className="submissions-kpi-data-container__list column">
        <SubmissionsKpiDataList
          submissions={this.props.submissions}
          submissionsType={this.props.submissionsType}
          mtd={this.props.mtd}
        />
      </div>
    );
  }

  render() {
    return (
      <div className="submissions-kpi-data-container">
        <div className="submissions-kpi-data-container__inner-wrap">
          <div className="submissions-kpi-data-container__actions columns">
            {this.renderTitleColumn()}
            {this.renderControlsColumn()}
          </div>
          <div className="submissions-kpi-data-container__main columns">
            {this.renderListColumn()}
            {this.renderChartColumn()}
          </div>
        </div>
      </div>
    );
  }
}

SubmissionsKpiData.propTypes = {
  mtdActions: PropTypes.object.isRequired,
  submissionsTypeActions: PropTypes.object.isRequired,
  chartDataTypeActions: PropTypes.object,
  kpis: PropTypes.object,
  kpiActions: PropTypes.object.isRequired,
  submissions: PropTypes.object.isRequired,
  mtd: PropTypes.bool.isRequired,
  submissionsType: PropTypes.string.isRequired,
  selectedPartner: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    submissions: state.kpis,
    mtd: state.mtd,
    submissionsType: state.submissionsType,
    kpis: state.kpis,
    selectedPartner: state.partner.selected
  };
}

function mapDispatchToProps(dispatch) {
  return {
    mtdActions: bindActionCreators(mtdActions, dispatch),
    submissionsTypeActions: bindActionCreators(submissionsTypeActions, dispatch),
    chartDataTypeActions: bindActionCreators(chartDataTypeActions, dispatch),
    kpiActions: bindActionCreators(kpiActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubmissionsKpiData);
